module.exports = __webpack_public_path__ + "img/heart.be5030ca.webp";